module.exports = __webpack_public_path__ + "img/transaction-points.ec75ad5d.svg";